const RENT_AND_UTILITIES: 'rent-and-utilities' = 'rent-and-utilities'
const RENT_ONLY: 'rent-only' = 'rent-only'
const UTILITIES_ONLY: 'utilities-only' = 'utilities-only'
const SEASONAL_ONLY: 'seasonal-only' = 'seasonal-only'

const LONG_TERM_RESERVATION_KINDS = { RENT_AND_UTILITIES, RENT_ONLY, UTILITIES_ONLY, SEASONAL_ONLY }
type longTermReservationKind = typeof RENT_AND_UTILITIES | typeof RENT_ONLY | typeof UTILITIES_ONLY | typeof SEASONAL_ONLY

export {LONG_TERM_RESERVATION_KINDS}
export type { longTermReservationKind }
